import React from 'react';

import { Card, LinearProgress, Stack } from '@gogame/components';

export const StandardLayout = ({ children, attributes }) => {
  return (
    <Stack spacing={2} alignItems={'center'} justifyContent={'center'}>
      {children ? <Stack>{children}</Stack> : null}
      {attributes}
    </Stack>
  );
};

export const OutlinedLayout = ({ children, attributes, progress }) => {
  return (
    <Card elevation={4} fullHeight={true}>
      <Stack flex={'1 1 auto'}>
        {progress >= 0 && progress < 100 ? <LinearProgress /> : null}

        {children ? (
          <Stack
            alignItems={'center'}
            justifyContent={'center'}
            flex={'1 1 auto'}
          >
            {children}
          </Stack>
        ) : null}

        <Stack p={1}>{attributes}</Stack>
      </Stack>
    </Card>
  );
};
